import { render, staticRenderFns } from "./TabButtonText.vue?vue&type=template&id=64848a96&scoped=true"
import script from "./TabButtonText.vue?vue&type=script&lang=js"
export * from "./TabButtonText.vue?vue&type=script&lang=js"
import style0 from "./TabButtonText.vue?vue&type=style&index=0&id=64848a96&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64848a96",
  null
  
)

export default component.exports